import { render, staticRenderFns } from "./ComboBoxObjectMenu.vue?vue&type=template&id=8baf24c4&"
import script from "./ComboBoxObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ComboBoxObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports